import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-enterprise';
import {BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';                             
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoadingService } from 'src/app/services/loading/loading.service';

@Component({
    selector: 'app-s3-admin-portal-audit-trail',
    templateUrl: './s3-admin-portal-audit-trail.component.html',
    styleUrls: ['./s3-admin-portal-audit-trail.component.css'],
    standalone: false
})
export class S3AdminPortalAuditTrailComponent implements OnInit {

  orgId: any;
  orgUpdateForm: UntypedFormGroup;
  additionalMessageResponse: any;
  redirectedFromBol: any;
  profileName: any;
  currentMessage: any;
  messageArray = [];
  messages: any;
  audiTrailData: any;
  columnDefs: (ColDef | ColGroupDef)[];
  updateMessagesOptions: GridOptions = this.initializeGridOptions();
  rowData: any;
  public overlayNoRowsTemplate;
  private gridApi;

  constructor(private formBuilder: UntypedFormBuilder, 
    private alertService: AlertService,
    private tmssLoader: LoadingService,
    private route: ActivatedRoute,

    private bsModalRef: BsModalRef,
    public options: ModalOptions,
    ) {
      this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No rows to display, please adjust your filters</span>';
    this.orgUpdateForm = this.formBuilder.group({
      newMessage: new UntypedFormControl('')
    });
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        flex: 1,
        wrapText: true,
        autoHeight: true,
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      rowData: this.audiTrailData,
      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
  }

  /**
   * initializing the ag-grid
   * @param params
   */
   onGridReady(params: any) {
    // params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    // this.gridApi.setHeaderHeight(30);
    this.gridApi.setGridOption('headerHeight', 30);
  }
    
  
  ngOnInit() {
    //this.tmssLoader.show();
    console.log(this.options.initialState);

    this.audiTrailData = this.options.initialState;
    this.rowData = this.audiTrailData.auditTrailLogList;
    this.updateColumnDefs();
    this.profileName = this.audiTrailData.profile;  
    this.tmssLoader.hide(); 
  }


 updateColumnDefs() {
  this.columnDefs = this.getUpdateMessagesOptionsColumnDefs();
}

getUpdateMessagesOptionsColumnDefs(): (ColDef | ColGroupDef)[] {
  return [
    <ColDef>
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        autoHeight: true,
        headerName: 'Field Name',
        field: 'fieldName',
        filter: 'agTextColumnFilter', 
        sortable: true
       
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Old Value',
        field: 'oldValue',        
        filter: 'agTextColumnFilter', 
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'New Value',
        field: 'newValue',
        filter: 'agTextColumnFilter', 
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Update Date',
        field: 'updateDate',
        filter: 'agTextColumnFilter', 
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Update Date',
        field: 'updateDate',
        filter: 'agTextColumnFilter', 
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Updated By',
        field: 'updateEmailAddress',
        filter: 'agTextColumnFilter', 
        sortable: true
      }
    ];
}

  loadMessageHistory(existingMessages) {
    /* for(let i = 0; i<existingMessages.length(); i++) {
      this.messageHistoryArray[i] = existingMessages[i].message;
    } */
  }

  /**
   * @description cancel message entered
   */
  cancelMessage() {
    // this.bsModalRef.hide();
  }

  closeModal() {
    this.bsModalRef.hide();

  }


}